import React from 'react';
import { View, StyleSheet } from 'react-native';

import {
  paymentDataFragment,
  chargeDataFragment,
  installmentPlanDataFragment,
} from 'apollo/queries/autogenerate/operations';
import { ChargeKind } from 'apollo/queries/autogenerate/schemas';
import ChargeMessage from 'shared/modules/usage/components/molecules/ChargeMessage';
import ReceiptView from 'shared/modules/usage/components/organisms/ReceiptView';

type Props = {
  charge?: chargeDataFragment;
  payment?: paymentDataFragment | null;
  installmentPlan?: installmentPlanDataFragment | null;
  isConvertNpayEligible?: boolean;
};

export default function Receipt(props: Props) {
  const charge = props.charge;
  const payment = props.payment;
  const installmentPlan = props.installmentPlan;
  const isConvertNpayEligible = props.isConvertNpayEligible ?? false;
  const combiniFee =
    charge?.kind === ChargeKind.SETTLEMENT
      ? charge.metadata.settlementFeeAmount || undefined
      : undefined;

  return (
    <View>
      <ReceiptView
        charge={charge}
        payment={payment}
        combiniFee={combiniFee}
        installmentPlan={installmentPlan}
        isConvertNpayEligible={isConvertNpayEligible}
      />
      {charge?.kind !== ChargeKind.REFUND &&
        charge?.kind !== ChargeKind.LATE_FEE && (
          <View style={styles.chargeMessageContainer}>
            <ChargeMessage charge={charge} />
          </View>
        )}
    </View>
  );
}

const styles = StyleSheet.create({
  chargeMessageContainer: {
    paddingVertical: 24,
    paddingHorizontal: 16,
  },
});
